/**
 * Class for modelling the weight of a solution
 */
define([
    './SolventConcentrationSolutionModeler',
    './SolventSolutionModeler',
    './SpecieState'
], function (SolventConcentrationSolutionModeler, SolventSolutionModeler, SpecieState) {
    var instance = null;
    function WeightSolutionModeler() {
        // The default model used when no other model is selected
        this.DEFAULT = 0;

        // Stores the simulation model being used
        this.simulationModel = this.DEFAULT;
    };

    /**
     * Returns the weight for the solution
     * @param s The solution
     * @return The weight in grams
     */
    WeightSolutionModeler.prototype.getValue = function (s) {
        var weight = 0;

        // SOLVENTFINITE model
        if (SolventConcentrationSolutionModeler.simulationModel === SolventConcentrationSolutionModeler.SOLVENTFINITE) {
            // weight of species
            var i;
            for (i = 0; i < s.getSpeciesCount(); i++) {
                var sn = s.getSpeciesAt(i);
                weight += sn.getWeight();
            }
        }

        // SOLVENTINFINITE model
        else if (SolventConcentrationSolutionModeler.simulationModel === SolventConcentrationSolutionModeler.SOLVENTINFINITE) {
            // weight of solvent
            weight = s.liquidVolume * 1000
                * SolventSolutionModeler.getSolventDensity();

            // subtract the mass for the mols of water replaced
            for (i = 0; i < s.getSpeciesCount(); i++) {
                var sn = s.getSpeciesAt(i);
                if (sn.archetype.state !== SpecieState.SOLID) {
                    weight -= sn.getWaterReplaced()
                        * SolventSolutionModeler.getSolventMW();
                }
            }

            weight = (weight < 0) ? 0 : weight;

            // weight of species
            for (i = 0; i < s.getSpeciesCount(); i++) {
                var sn = s.getSpeciesAt(i);
                weight += sn.getWeight();
            }
        }
        return weight;
    };

    /**
     * Resets the default status
     */
    WeightSolutionModeler.prototype.setDefault = function () {
        this.simulationModel = this.DEFAULT;
    };

    WeightSolutionModeler.getInstance = function() {
        if(instance === null) {
            instance = new WeightSolutionModeler();
        }
        return instance;
    };
    return WeightSolutionModeler.getInstance();
});
